import { Flex, FloraButton } from '@grupoboticario/flora-react';

import { ResponsiveFloraTypography } from 'components';

import Styles from './Orders.styles';

export const Orders = () => {
  const goToOrders = () => window.location.replace('/pedidos?tab=historico');
  return (
    <Flex direction='column' gap='$4'>
      <Styles.LinkCard>
        <Flex direction='column' gap='$2'>
          <ResponsiveFloraTypography fontSize='subtitle' fontWeight='bold'>
            Pedidos realizados
          </ResponsiveFloraTypography>
          <ResponsiveFloraTypography
            fontSize='bodyLargeShort'
            fontWeight='medium'
            color='$nonInteractiveAuxiliar'
          >
            Confira os pedidos elegíveis que você realizou no histórico de pedidos.
          </ResponsiveFloraTypography>
        </Flex>

        <FloraButton
          data-testid='orders-button'
          onClick={goToOrders}
          autotagging-flora='on'
          data-flora='button'
          data-flora-text='acessar-historico'
          hierarchy='secondary'
          styleSemantic='neutral'
        >
          <ResponsiveFloraTypography fontSize='bodySmallShort'>
            Acessar histórico de pedidos
          </ResponsiveFloraTypography>
        </FloraButton>
      </Styles.LinkCard>
    </Flex>
  );
};
